import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Icon from '../icon/Icon';
import { openModal } from '../../components/modal/actions';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

const GlobalToolTip = ({ className, content, icon, openModal, title, titleAttr, ...props }) => {
  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    openModal({
      type: 'tooltip',
      title,
      content,
      element: e.target,
      noPadding: true
    });
  };

  const currTitle = titleAttr || content;
  return (
    <Icon
      className={className}
      name={icon}
      alt={new TranslatedCopy({ id: 'global.moreInfo' }).toString()}
      title={typeof currTitle === 'string' ? currTitle : null}
      onClick={handleClick}
      style={{ cursor: typeof handleClick === 'function' ? 'pointer' : 'default' }}
      {...props}
    />
  );
};

GlobalToolTip.defaultProps = {
  className: null,
  icon: 'filled-question',
  title: null,
  titleAttr: null
};

GlobalToolTip.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  content: PropTypes.any.isRequired,
  openModal: PropTypes.func.isRequired,
  title: PropTypes.string,
  titleAttr: PropTypes.string
};

const connector = connect(() => ({}), {
  openModal
});

export default connector(GlobalToolTip);
